import React from "react";
import { View } from "react-native";
import { s } from "react-native-size-matters";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../../Components/skeleton-components/Skeletons";
import Separator from "../Separator";

const AccountTabSkeleton: React.FC = () => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  return (
    <View style={styles.container}>
      {/* Header Section */}
      <View style={styles.header}>
        <Skeletons
          width={"120px"}
          height={"20px"}
          style={{ borderRadius: s(4) }}
        />
        <Separator
          color={AppColors.green_4CD964}
          height={2}
          marginTop={5}
          marginBottom={0}
          width={"40"}
          marginHorizontal={0}
        />
      </View>

      {/* Account Fields */}
      <View style={styles.content}>
        {/* Email Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Username Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* First Name Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Last Name Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Bio Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"100px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Language Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Country Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Time Zone Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Avatar Field */}
        <View style={styles.accountData}>
          <Skeletons
            width={"80px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <Skeletons
            width={"284px"}
            height={"100px"}
            style={{ borderRadius: s(10) }}
          />
        </View>

        {/* Messaging Options */}
        <View style={[styles.accountData, { alignItems: "flex-start" }]}>
          <Skeletons
            width={"120px"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
          <View
            style={{
              width:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "100%"
                  : "301px",
            }}
          >
            {[...Array(4)].map((_, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: s(20),
                  marginBottom: s(20),
                }}
              >
                <Skeletons
                  width={"17px"}
                  height={"17px"}
                  style={{ borderRadius: s(12) }}
                />
                <Skeletons
                  width={"200px"}
                  height={"14px"}
                  style={{ borderRadius: s(4) }}
                />
              </View>
            ))}
          </View>
        </View>

        {/* Save Button */}
        {/* <View style={styles.buttonContainer}>
          <Skeletons
            width={"80px"}
            height={"40px"}
            style={{ borderRadius: s(10) }}
          />
        </View> */}
      </View>
    </View>
  );
};

export default AccountTabSkeleton;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: AppColors.purple_453B50,
      borderRadius: s(10),
      padding: 40,
    },
    header: {
      // paddingTop: s(30),
      paddingBottom: s(50),
    },
    content: {
      flex: 1,
    },
    accountData: {
      flexDirection: "row",
      gap: s(20),
      alignItems: "center",
      marginBottom: s(20),
    },
    // buttonContainer: {
    //   flexDirection: "row",
    //   justifyContent: "flex-end",
    //   width: "390px",
    // },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      header: {
        paddingTop: 0,
        paddingBottom: s(20),
      },
      accountData: {
        flexDirection: "column",
        gap: s(10),
        alignItems: "flex-start",
      },
      //   buttonContainer: {
      //     justifyContent: "center",
      //     width: "auto",
      //   },
    },
    [DEVICE_SIZES.XS]: {
      header: {
        paddingTop: 0,
        paddingBottom: s(20),
      },
      accountData: {
        flexDirection: "column",
        gap: s(10),
        alignItems: "flex-start",
      },
      //   buttonContainer: {
      //     justifyContent: "center",
      //     width: "auto",
      //   },
    },
  }
);
